import { faFileUpload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as openpgp from 'openpgp';
import * as React from 'react';
import { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { Error, MagebitExclusively } from './Create';
import Result from './Result';
import { randomString, uploadFile } from './utils';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

const Upload = () => {
  const maxSize = 1024 * 500;
  const [password, setPassword] = useState('');
  const [exclusive, setExclusive] = useState(true);
  const [error, setError] = useState('');
  const [uuid, setUUID] = useState('');
  const [reset, setReset] = useState(false);
  const { t } = useTranslation();

  const onDrop = React.useCallback(
    (acceptedFiles: File[]) => {
      const reader = new FileReader();
      reader.onabort = () => console.log('file reading was aborted');
      reader.onerror = () => console.log('file reading has failed');
      reader.onload = async () => {
        const pw = randomString();
        const file = await openpgp.encrypt({
          armor: true,
          message: openpgp.message.fromBinary(
            new Uint8Array(reader.result as ArrayBuffer),
            acceptedFiles[0].name,
          ),
          passwords: pw,
        });
        const { data, status } = await uploadFile({
          message: file.data,
          exclusive: exclusive,
        });

        if (status !== 200) {
          setError(data.message);
        } else {
          setUUID(data.message);
          setPassword(pw);
        }
      };
      acceptedFiles.forEach((file) => reader.readAsArrayBuffer(file));
    },
    [exclusive],
  );

  const {
    getRootProps,
    getInputProps,
    fileRejections,
    isDragActive,
  } = useDropzone({
    maxSize,
    minSize: 0,
    onDrop,
  });

  if (reset) {
    setUUID('');
    setPassword('');
    setExclusive(true);
    setReset(false);
  }

  const isFileTooLarge =
    fileRejections.length > 0 &&
    fileRejections[0].errors[0].code === 'file-too-large';

  return (
    <div className="text-center">
      {isFileTooLarge && <Error message={t('File is too large')} />}
      <Error message={error} onClick={() => setError('')} />
      {uuid ? (
        <Result uuid={uuid} password={password} prefix="f" actions={{setReset}}/>
      ) : (
        <div>
          <div {...getRootProps()} className="file-upload">
            <input {...getInputProps()} />
            <div className="text-center mt-5">
              <h4 className={'c-gray fs-32'}>{t('Drop file to upload')}</h4>
              <p className="c-light-gray fs-16">
                {t(
                  'File upload is limited to small files; Think ssh keys and similar.',
                )}
              </p>
              <FontAwesomeIcon
                color={isDragActive ? '#017AFF' : '#9BA4B5'}
                size="8x"
                icon={faFileUpload}
              />{' '}
            </div>
          </div>
          <div className="exclusive-share">
            <MagebitExclusively setExclusive={setExclusive} exclusive={exclusive} />
          </div>
          <div className={'text-left'}>
            <NavLink to={'/'}>Share message instead</NavLink>
          </div>
        </div>
      )}
    </div>
  );
};

export default Upload;
